import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import TableCollaborator from "../../TableCollaborator/TableCollaborator";
import moment from "moment";
moment.locale("es");

export default defineComponent({
  name: "approval",
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    objectEdit: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data: () => ({
    showImgLeft: true,
  }),
  computed: {
    headerImgLeft() {
      return this.backendPath.concat(
        `/modules/permisos-sindicales/letters/societies/${this.businessPartner.society}_.png`
      );
    },
    headerImgRight() {
      return this.backendPath.concat("/modules/common/img/logo.png");
    },
    headerCaption() {
      return window.location.host || "";
    },
    backgroundImagePath() {
      return {
        backgroundImage: `url(${this.backendPath.concat(
          "/modules/common/img/logo-with-opacity.png"
        )})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "50% 70%",
        backgroundSize: "60%",
      };
    },
    licenseEmployee() {
      return this.getLicenseGetter.license_employees || {};
    },
    destinationCityName() {
      const { site } = this.getLicenseGetter.petitioner || {};
      return site
        ? site.city
          ? this.capitalizeText(site.city.name)
          : "<Petitioner city>"
        : "<Petitioner city>";
    },
    // ## FECHA EN QUE SE MODIFICA LA CARTA
    createdAt() {
      return this.getLastDateToRetraction
        ? this.getLastDateToRetraction
        : this.get_today;
    },
    getLastDateToRetraction() {
      const me = this;
      let date = null

      const record = me.traceabilityGetter?.data[0]?.audits?.find((audit) => audit.status === "retraction")

      if (record) date = record?.updated_at;

      return date;
      // let maxId = 0;
      // let result = null;
      // this.licenseEmployee.forEach(({ audits }) => {
      //   audits.forEach((audit) => {
      //     let auditId = audit.id;
      //     if (auditId > maxId) {
      //       maxId = auditId;
      //       result = audit.created_at;
      //     }
      //   });
      // });
      // return result;
    },
    laborUnionName() {
      return this.getLicenseGetter.labor_union
        ? this.getLicenseGetter.labor_union.name
        : null;
    },
    petitioner() {
      return {
        name: this.getLicenseGetter.petitioner
          ? this.getLicenseGetter.petitioner.name
          : null,
        role: this.getLicenseGetter.petitioner
          ? this.getLicenseGetter.petitioner.core_role
            ? this.getLicenseGetter.petitioner.core_role.name
            : "<Solicitante Sindical>"
          : "<Solicitante Sindical>",
      };
    },
    licenseId() {
      return this.getLicenseGetter.id || null;
    },
    /**
     * Se filtran los que ya tienen el estado de rechados y los que son editable en caso de que le de a editar
     */
    getCollaborators() {
      if (Object.keys(this.licenseEmployee).length > 0) {
        const uniqueIdsIfEdit = this.isEdit
          ? this.objectEdit.license
            ? new Set(this.objectEdit.license.map((item) => item.day))
            : new Set()
          : new Set();
        const statesPermit = ["retraction"];
        return this.licenseEmployee
          .map(
            ({ retraction_motive, core_employee, days, sharp_id, ticket }) => ({
              motive: retraction_motive,
              name: core_employee.name,
              ticket,
              sharp_id,
              core_employee,
              days: days.filter(
                ({ id, status }) =>
                  statesPermit.includes(status) || uniqueIdsIfEdit.has(id)
              ),
            })
          )
          .filter(({ days }) => days.length > 0);
      }
      return [];
    },
    getMotiveToString() {
      const uniqueMotivesSet = new Set();
      this.getCollaborators.forEach((collaborator) => {
        const motive = collaborator.motive;
        if (!uniqueMotivesSet.has(motive)) {
          uniqueMotivesSet.add(motive);
        }
      });
      return Array.from(uniqueMotivesSet).join(", ");
    },
    getLastDay() {
      return (array) => {
        if (array.length === 0) return null;
        return array.slice(-1)[0].day || null;
      };
    },
    canBeDownloaded() {
      return this.getCollaborators.length > 0;
    },
    businessPartner() {
      return {
        name: this.getLicenseGetter.bp
          ? this.getLicenseGetter.bp.name
          : "< Business Partner >",
        role: this.getLicenseGetter.bp
          ? this.getLicenseGetter.bp.core_role
            ? this.getLicenseGetter.bp.core_role.name
            : "< Business Partner >"
          : "< Business Partner >",
        society: this.getLicenseGetter.bp
          ? this.getLicenseGetter.bp.society
            ? this.getLicenseGetter.bp.society.name
            : "< Bavaria >"
          : "< Bavaria >",
        signature: this.getLicenseGetter.bp
          ? this.backendPath.concat(this.getLicenseGetter.bp.signature)
          : "#",
      };
    },
    ...mapGetters("permisosSindicalesV2License", ["getLicenseGetter", "traceabilityGetter"]),
    fields() {
      return [
        {
          key: "collaborator",
          label: "Colaborador",
        },
        {
          key: "sharp_id",
          label: "Sharp ID",
        },
        {
          key: "identification",
          label: "Cédula",
        },
        {
          key: "date",
          label: "Fecha",
        },
      ];
    },
    items() {
      const me = this;
      let records = [];

      const { tickets } = me.getLicenseGetter;
      if (tickets) {
        me.fields.push(
          {
            key: "city_initial",
            label: "Desde",
          },
          {
            key: "city_final",
            label: "Hacia",
          }
        );
      } else {
        me.fields.push({
          key: "city",
          label: "Ciudad",
        });
      }
      me.getCollaborators.forEach((item) => {
        records.push(me.dataTable(item));
      });

      return records;
    },
  },
  mounted() {
    this.$emit("change:canBeDownloaded", { value: this.canBeDownloaded });
  },
  watch: {
    canBeDownloaded() {
      this.$emit("change:canBeDownloaded", { value: this.canBeDownloaded });
    },
  },
  methods: {
    handleImgErrorLeft() {
      this.showImgLeft = false;
    },
    daysOrderMonth(items) {
      let days = [];
      items?.forEach((day) => {
        const month = moment(day?.day).format("MMMM");
        const record = days.find((item) => item.month === month);
        if (record) {
          record.dates.push(day?.day);
        } else {
          days.push({
            month: month,
            dates: [day?.day],
          });
        }
      });
      return days;
    },
    dataTable(data) {
      const me = this;
      return {
        collaborator: data?.core_employee?.name,
        sharp_id: data?.core_employee?.sharp_id,
        identification: data?.core_employee?.cc,
        dates: me.daysOrderMonth(data?.days),
        ticket: {
          type: data?.ticket?.type?.toLowerCase(),
          city: data?.ticket?.origin_city?.name,
          origin_department: data?.ticket?.origin_city?.department_?.name,
          destination: data?.ticket?.destination_city_name,
          destination_department:
            data?.ticket?.destination_department?.name.toLowerCase(),
        },
      };
    },
  },
  components: {
    TableCollaborator,
  },
});
